import ChangeTransactionCategorySettingsPopup from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/ChangeTransactionCategorySettingsPopup.vue'; // eslint-disable-line
import MoveToFixedConfirmationPopup from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/MoveToFixedConfirmationPopup.vue'; // eslint-disable-line
import MoveToExcludedConfirmationPopup from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/MoveToExcludedConfirmationPopup.vue'; // eslint-disable-line
import MoveFromExcludedConfirmationPopup from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/MoveFromExcludedConfirmationPopup.vue'; // eslint-disable-line
// eslint-disable-next-line max-len
import MoveFromFixedConfirmationPopup from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/MoveFromFixedConfirmationPopup';
import ChangeTransactionCategorySummaryPopup
  from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/ChangeTransactionCategorySummaryPopup'; // eslint-disable-line

const CATEGORY_NAMES = {
  VARIABLE: 'variable',
  VARIABLE_INCOME: 'variableIncome',
  VARIABLE_EXPENSE: 'variableExpense',
  FIXED_EXPENSE: 'fixedExpense',
  FIXED_INCOME: 'fixedIncome',
  EXCLUDED_INCOME: 'excludedIncome',
  EXCLUDED_EXPENSE: 'excludedExpense',
  TRACKING: 'tracking',
  TRACKING_CATEGORY: 'trackingCategory',
};

const TRACKING_CATEGORY_TYPE = {
  ECONOMY: 'כלכלה',
};

const CASHFLOW_CATEGORIES = {
  VARIABLE: 'variable',
  FIXED: 'fixed',
  FIXED_INCOME: 'fixed-income',
  TRACKING: 'tracking',
  VARIABLE_INCOME: 'variable-income',
  EXCLUDED_INCOME: 'excluded-income',
  EXCLUDED_EXPENSE: 'excluded-expense',
  RISEUP_GOAL: 'riseup-goal',
};

const CATEGORY_STYLE = {
  [CASHFLOW_CATEGORIES.TRACKING]: 'primary',
  [CASHFLOW_CATEGORIES.VARIABLE]: 'warning',
  [CASHFLOW_CATEGORIES.FIXED]: 'fixed',
  [CASHFLOW_CATEGORIES.VARIABLE_INCOME]: 'success',
  [CASHFLOW_CATEGORIES.FIXED_INCOME]: 'success',
  [CASHFLOW_CATEGORIES.RISEUP_GOAL]: 'success',
  [CASHFLOW_CATEGORIES.EXCLUDED_INCOME]: 'neutral',
  [CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE]: 'neutral',
};

const OTHER_CATEGORY = 'אחר';

const PAYMENT_METHODS_FIXED_EXPENSE_CATEGORIES = [
  'תשלומים',
  'העברות',
  'שיק',
  'מזומן',
];

const TRANSFERABLE_FIXED_INCOME_CATEGORIES = [
  'משכורת',
  'דיור',
  'קצבאות',
];

// These are the top 11 categories that customers moved expenses to recently
const TRANSFERABLE_FIXED_EXPENSE_CATEGORIES = [
  'לחסכון',
  'ביטוח',
  'דיגיטל',
  'הלוואה',
  'תשלומים',
  'אחר',
  'תרומה',
  'מנויים',
  'חינוך',
  'דיור',
];

export default {
  cashflowTypes: {
    income: 'income',
    car: 'car',
    economy: 'economy',
    fixedExpense: 'fixedExpense',
    variableExpense: 'variableExpense',
    excluded: 'excluded',
    riseupGoal: 'riseupGoal',
    trackingCategory: 'trackingCategory',
  },
  envelopeTimeFrames: {
    weekly: 'weekly',
    monthly: 'monthly',
  },
  weekTimeFrames: {
    past: 'past',
    current: 'current',
    future: 'future',
  },
  CATEGORIES: [
    { categoryName: CATEGORY_NAMES.VARIABLE, expense: 'משתנות', cashflowCategory: CASHFLOW_CATEGORIES.VARIABLE, icon: '🤹‍', label: 'משתנה', pluralLabel: 'משתנות', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.VARIABLE], targetPopup: ChangeTransactionCategorySettingsPopup, finalPopup: ChangeTransactionCategorySummaryPopup  }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.VARIABLE_INCOME, expense: 'הכנסות משתנות', cashflowCategory: CASHFLOW_CATEGORIES.VARIABLE_INCOME, icon: '🤹‍', label: 'משתנה', pluralLabel: 'משתנות', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.VARIABLE_INCOME], targetPopup: ChangeTransactionCategorySettingsPopup, }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.FIXED_EXPENSE, cashflowCategory: CASHFLOW_CATEGORIES.FIXED, icon: '📅‍', label: 'קבועה', pluralLabel: 'קבועות', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.FIXED], confirmationPopup: MoveFromFixedConfirmationPopup, targetPopup: MoveToFixedConfirmationPopup  }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.FIXED_INCOME, cashflowCategory: CASHFLOW_CATEGORIES.FIXED_INCOME, icon: '📅‍', label: 'קבועה', pluralLabel: 'קבועות', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.FIXED_INCOME], confirmationPopup: MoveFromFixedConfirmationPopup, targetPopup: MoveToFixedConfirmationPopup, }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.EXCLUDED_EXPENSE, cashflowCategory: CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE, icon: '🚫', label: 'לא תזרימית', pluralLabel: 'לא תזרימיות', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE], confirmationPopup: MoveFromExcludedConfirmationPopup, targetPopup: MoveToExcludedConfirmationPopup }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.EXCLUDED_INCOME, cashflowCategory: CASHFLOW_CATEGORIES.EXCLUDED_INCOME, icon: '🚫', label: 'לא תזרימית', pluralLabel: 'לא תזרימיות', confirmationPopup: MoveFromExcludedConfirmationPopup, style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.EXCLUDED_INCOME], targetPopup: MoveToExcludedConfirmationPopup, }, // eslint-disable-line
  ],
  CATEGORY_NAMES,
  CASHFLOW_CATEGORIES,
  TRACKING_CATEGORY_TYPE,
  CATEGORY_STYLE,
  AVAILABLE_CASHFLOW_CATEGORIES: {
    [CASHFLOW_CATEGORIES.VARIABLE]: [
      CASHFLOW_CATEGORIES.VARIABLE,
      CASHFLOW_CATEGORIES.FIXED,
      CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE,
      CASHFLOW_CATEGORIES.TRACKING,
    ],
    [CASHFLOW_CATEGORIES.FIXED]: [
      CASHFLOW_CATEGORIES.VARIABLE,
      CASHFLOW_CATEGORIES.FIXED,
      CASHFLOW_CATEGORIES.TRACKING,
      CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE,
    ],
    [CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE]: [
      CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE,
      CASHFLOW_CATEGORIES.VARIABLE,
    ],
    [CASHFLOW_CATEGORIES.EXCLUDED_INCOME]: [
      CASHFLOW_CATEGORIES.EXCLUDED_INCOME,
      CASHFLOW_CATEGORIES.VARIABLE_INCOME,
    ],
    [CASHFLOW_CATEGORIES.TRACKING]: [
      CASHFLOW_CATEGORIES.VARIABLE,
      CASHFLOW_CATEGORIES.TRACKING,
      CASHFLOW_CATEGORIES.FIXED,
      CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE,
    ],
    [CASHFLOW_CATEGORIES.VARIABLE_INCOME]: [
      CASHFLOW_CATEGORIES.VARIABLE_INCOME,
      CASHFLOW_CATEGORIES.FIXED_INCOME,
      CASHFLOW_CATEGORIES.EXCLUDED_INCOME,
    ],
    [CASHFLOW_CATEGORIES.FIXED_INCOME]: [
      CASHFLOW_CATEGORIES.VARIABLE_INCOME,
      CASHFLOW_CATEGORIES.FIXED_INCOME,
    ],
  },
  PAYMENT_METHODS_FIXED_EXPENSE_CATEGORIES,
  TRANSFERABLE_FIXED_INCOME_CATEGORIES,
  TRANSFERABLE_FIXED_EXPENSE_CATEGORIES,
  OTHER_CATEGORY,
};
